import { render, staticRenderFns } from "./AudioIcon.vue?vue&type=template&id=97c3a4a0&scoped=true"
import script from "./AudioIcon.vue?vue&type=script&lang=js"
export * from "./AudioIcon.vue?vue&type=script&lang=js"
import style0 from "./AudioIcon.vue?vue&type=style&index=0&id=97c3a4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c3a4a0",
  null
  
)

export default component.exports